import { chartsConfigReducer } from "./charts/reducer";
import { dashboardDataReducer } from "./data/reducer";
import { dashboardEditReducer } from "./editMode/reducer";
import { filtersConfigReducer } from "./filters/reducer";
import { dashboardSegmentsReducer } from "./segments/reducer";
import { DashboardInitialStateType } from "./types";

export const dashboardReducer = (
	{ data, filtersConfig, chartsConfig, dashboardEdit, segmentsConfig }: DashboardInitialStateType,
	action: Record<string, any>
): DashboardInitialStateType => ({
	data: dashboardDataReducer(data, action),
	filtersConfig: filtersConfigReducer(filtersConfig, action),
	chartsConfig: chartsConfigReducer(chartsConfig, action),
	dashboardEdit: dashboardEditReducer(dashboardEdit, action),
	segmentsConfig: dashboardSegmentsReducer(segmentsConfig, action),
});
